import {get} from '../../lib/apiClient'


export async function getList(): Promise<string[]> {
  return get<string[]>('json-documents/document-classes')
}
